import { Tournament, TournamentStatus, TournamentType } from '../../domain/models';

// DTO que representa la estructura en Supabase
export interface TournamentEntity {
  id: string;
  name: string;
  description: string | null;
  tournament_type: string;
  status: string;
  max_participants: number | null;
  user_id: string;
  is_public: boolean;
  created_at: string;
  updated_at: string;
  rules: string | null;
  location: string | null;
  location_lat: number | null;
  location_lng: number | null;
  start_date: string | null;
  league_id: string | null;
  invite_code: string | null;
}

// Mapper: de Entity (DB) a Model (Domain)
export const tournamentEntityToModel = (entity: TournamentEntity): Tournament => {
  return {
    id: entity.id,
    name: entity.name,
    description: entity.description || undefined,
    tournamentType: entity.tournament_type as TournamentType,
    status: entity.status as TournamentStatus,
    maxParticipants: entity.max_participants || undefined,
    userId: entity.user_id,
    isPublic: entity.is_public,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
    rules: entity.rules || undefined,
    location: entity.location || undefined,
    locationLat: entity.location_lat || undefined,
    locationLng: entity.location_lng || undefined,
    startDate: entity.start_date ? new Date(entity.start_date) : undefined,
    leagueId: entity.league_id || undefined,
    inviteCode: entity.invite_code || undefined,
  };
};

// Mapper: de Model (Domain) a Entity (DB)
export const tournamentModelToEntity = (model: Partial<Tournament>): Partial<TournamentEntity> => {
  return {
    ...(model.name !== undefined && { name: model.name }),
    ...(model.description !== undefined && { description: model.description || null }),
    ...(model.tournamentType !== undefined && { tournament_type: model.tournamentType }),
    ...(model.status !== undefined && { status: model.status }),
    ...(model.maxParticipants !== undefined && { max_participants: model.maxParticipants || null }),
    ...(model.userId !== undefined && { user_id: model.userId }),
    ...(model.isPublic !== undefined && { is_public: model.isPublic }),
    ...(model.rules !== undefined && { rules: model.rules || null }),
    ...(model.location !== undefined && { location: model.location || null }),
    ...(model.locationLat !== undefined && { location_lat: model.locationLat || null }),
    ...(model.locationLng !== undefined && { location_lng: model.locationLng || null }),
    ...(model.startDate !== undefined && { start_date: model.startDate ? model.startDate.toISOString() : null }),
    ...(model.leagueId !== undefined && { league_id: model.leagueId || null }),
    ...(model.inviteCode !== undefined && { invite_code: model.inviteCode || null }),
  };
};